import type { ReactNode } from 'react';

import { cn } from '@kit/ui/utils';

export function SitePageHeader({
  title,
  subtitle,
  container = true,
  className = '',
}: {
  title: string;
  subtitle?: ReactNode;
  container?: boolean;
  className?: string;
}) {
  const containerClass = container ? 'container' : '';

  return (
    <div className={cn('pt-10 pb-2 xl:pt-12 xl:pb-3', className)}>
      <div
        className={cn(
          'flex flex-col items-center gap-y-2 lg:gap-y-3',
          containerClass,
        )}
      >
        <div className="inline-flex items-center gap-3">
          <span
            aria-hidden="true"
            className="hidden h-px w-10 bg-slate-300 sm:block dark:bg-slate-600"
          />
          <h1 className="font-heading relative -skew-x-3 px-3 py-1 text-base font-semibold tracking-[0.08em] text-slate-700 uppercase italic sm:text-lg dark:text-slate-200">
            <span
              aria-hidden="true"
              className="absolute right-0 bottom-0 left-0 h-[0.8em] -skew-x-3 rounded-[2px] bg-green-300/70 dark:bg-green-500/25"
            />
            <span className="relative z-10">{title}</span>
          </h1>
          <span
            aria-hidden="true"
            className="hidden h-px w-10 bg-slate-300 sm:block dark:bg-slate-600"
          />
        </div>

        {subtitle && (
          <h2
            className={
              'text-muted-foreground text-xs tracking-tight sm:text-sm'
            }
          >
            {subtitle}
          </h2>
        )}
      </div>
    </div>
  );
}
